<template>
  <div>
    <footer class="bg-primary py-5">
      <div class="container">
        <p class="text-center" style="color: #e3dfcf;">© Copyright 2018 V-MARKET</p>
      </div>
    </footer>
  </div>
</template>


<script>
export default {
  name: "Footer"
};
</script>



// WEBPACK FOOTER //
// src/components/Shop/Footer.vue